module.exports = __webpack_public_path__ + "img/paypal.c0887ce3.png";